import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect, useHistory, useLocation } from "react-router-dom";
import TitleBar from "../TitleBar/TitleBar";
import { CreateTitleBar, CreateTitlebarProps} from "../TitleBar/CreateTitlebar";
import "../../theme/styles.css";
import { SortOtsCards, FilterOpenEvents, setDragAndDropOrder } from "../Sort/SortOtsCards";
import { OtsAircraft } from "../../Models/OtsAircraft";
import CreateOTSEvent from "../OtsForm/CreateOTSEvent";
import EventDetails from "../EditOtsForm/EventDetails";
import EditModal from "../EditOtsForm/EditModal";
import OTSModal from "../Modal/OTSModal";
import { editAircraft } from "../../store/feature/OtsAircraftSlice";
import { useDispatch, useSelector } from "react-redux";
import { getOpenEvents, checkForEventReload } from "../../services/otsEventService";
import { useAuthentication } from "meportal/AuthenticationProvider";
import { useEventType } from "../../providers/EventTypeProvider";
import { EventType } from "@testing-library/react";
import { addOpenEventsMasterList, openEvents, setLastRefreshed } from "../../store/feature/OpenEventsListSlice";
import OtsEventCardTile from "../OtsEventCard/OtsEventCardTile";
import '../OtsEventCard/OtsDashboardGrid.scss';
import BackToTopButton from "../../helpers/BackToTopButton";
import { useViewableEventTypes } from "../../providers/ViewEventTypeProvider";
import { setDragAndDropEventList, setFilters, setSort } from "../../store/feature/FilterSortSlice";
import { ToastComponent } from "../ToastNotification/toast";
import { ToastContainer } from 'react-toastify';
import AlertBanner from 'meportal/AlertBanner';
import AlertBannerContainer from 'meportal/AlertBannerContainer';
import { logInformation} from "meportal/Logger";
import { getDatetimeUtcNowString } from "../../helpers/DateTime";
import SyncStatus from "./SyncStatus";
import * as Constants from "../../constants/Constants";
import  CreateOTSFleetEvent from "../OTSFleetEvent/CreateOTSFleetEvent";
import { InlineNotificationProvider } from '../../providers/InlineNotificationProvider';
import { GlobalTimerProvider } from '../../providers/GlobalTimerProvider';
import OtsDashboardList from "../OtsEventCard/OtsDashboardList";
interface VisibleEventTypes {
    [key: string]: boolean;
}

export default function OpenEventsDashboard(permittedEventTypes: any) {
    const { userData, getLatestAccessToken } = useAuthentication();
    const openEventsMasterList = useSelector((state: any) => state.openEvents.openEventsMasterList);
    const viewEventTypes = useViewableEventTypes()?.viewEventTypes; // Add null check before accessing 'viewEventTypes'
    const { eventTypes, selectedEventType } = useEventType();
    const eventTypeFilters = useSelector((state: any) => state.filterSort.filters);
    const moduleName = `${Constants.APP_NAME_APPINSIGHTS}-OpenEventsDashboard`;
    const history = useHistory();
    const rootPath = "/open-events";
    const createPath = rootPath + "/create-ots";
    const editModalPath = rootPath + "/edit-ots";
    const createFleetPath = rootPath + "/create-new-fleet-type-event";
    const location = useLocation();
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(true);
    //const [otsaircraft, setOtsDashboard] = useState<OtsAircraft[]>([]);
    const [selectedField, setSelectedField] = useState("");
    const [clickCount, setClickCount] = useState<number>(0);
    const [loadedData, setLoadedData] = useState(false);
    const [open, setOpen] = useState(false);
    // const [editToggle, setEditToggle] = useState(false); //changing edit modal open close
    const dispatch = useDispatch();
    const otsaircraft = useSelector((state: any) => state.openEvents.openEventsList);
    const lastRefreshed = useSelector((state: any) => state.openEvents.lastRefreshed);
    const [createdata, Setcreatedata] = useState<CreateTitlebarProps>({
        status: "",
        isSubmitDisabled: true,
        handleClose: () => { },
        handleAddSubmit: () => { }
    });
    const [otsFleetTypeData, setOtsFleetTypeData] = useState<CreateTitlebarProps>({
        status: "",
        isSubmitDisabled: true,
        handleClose: () => {},
        handleAddSubmit: () => {}
    });
    const [draggedEventType, setDraggedEventType] = useState<string | null>(null);
    const [visibleEventTypes, setVisibleEventTypes] = useState<VisibleEventTypes>({});
    const [refreshCount, setRefreshCount] = useState(0);
    const defaultSort = useSelector((state: any) => state.filterSort.sort);
    const [conversationFilter, setConversationFilter] = useState<any>(null);
    const dragAndDropEventList = useSelector((state: any) => state.filterSort.dragAndDropEventList);
    const toggleVisibility = (eventType: string) => {
        setVisibleEventTypes((prevState: VisibleEventTypes) => {
            const isCurrentlyVisible = prevState[eventType];
    
            return {
                ...prevState,
                [eventType]: isCurrentlyVisible === undefined ? false : !isCurrentlyVisible
            };
        });
    };

      const viewMode = useSelector((state: any) => state.view.viewMode);

    async function fetchOrGetOpenEvents(data: any) {
        if (data && data.length > 0) {

            setIsLoaded(true);
            const hasMissingId = data.some((item: { id: any; }) => !item.id);
            if (hasMissingId) {
                getOpenEventsFromSource();
            }
            else {
                let filteredEvents = FilterOpenEvents(eventTypeFilters, data);
                let viewable = filteredEvents.filter((aircraft: any) => viewEventTypes?.some((viewableEventType: any) => viewableEventType.Name === aircraft.EventType));
                let list = SortOtsCards(eventTypeFilters, viewable, defaultSort.split('-')[0], parseInt(defaultSort.split('-')[1]));
                if (dragAndDropEventList.length > 0) {
                    list = setDragAndDropOrder(list, viewEventTypes ?? [], dragAndDropEventList);
                }
                setIsLoaded(true);
                dispatch(openEvents(list));

                // Do a refresh after loading from redux
                getOpenEventsFromSource();
                logInformation(
                    `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Refresh data from source. User: ${userData?.profile?.email}`,
                    moduleName,
                    "fetchOrGetOpenEvents"
                  );
            }
        }
        else if (userData.profile.company.trim() !== "" && userData.access_token !== "" && location.pathname === rootPath) {
            setIsLoaded(false);
            getOpenEventsFromSource();
        }
    }

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if (location.pathname === rootPath) {
                if (Array.isArray(viewEventTypes) && viewEventTypes.length > 0) {
                    fetchOrGetOpenEvents(openEventsMasterList);
                }
            }
        }
        return () => {
            isMounted = false;
        };
    }, [userData.access_token, location.pathname, viewEventTypes]);

    function refreshExpired() {
        if (refreshCount >= 1) { // When refresh count is 1 (i.e. 30 secs.), force refresh
            setRefreshCount(0);
            return true;
        }
        setRefreshCount(refreshCount + 1);
        return false;
    }


    const checkMountedExpired = (isMounted: any) => {
        if (isMounted) {
            if (refreshExpired()) {
                getOpenEventsFromSource();
            }
        }
    }
    const handleData = (data: any, isMounted: any) => {
        if (data) {
            if (data.Refresh === true) {
                if (isMounted) {
                    getOpenEventsFromSource();
                }
            }
        }
    }

    useEffect(() => {
        let isMounted = true;
        const timer = setInterval(() => {
            if (location.pathname !== createPath && location.pathname !== editModalPath && location.pathname !== createFleetPath) {
                // get the event types currently shown on the dashboard 
                if (Array.isArray(otsaircraft) && otsaircraft.length > 0) {
                    const propertyValues = otsaircraft.map(item => item.EventType);
                    const distinctEventTypeValues = propertyValues.filter((value, index, self) => self.indexOf(value) === index);
                    let fetchDateTime = lastRefreshed;
                    if (fetchDateTime === undefined || fetchDateTime === "") {
                        let date = new Date();
                        date.setHours(date.getHours() - 10);
                        fetchDateTime = date.toISOString();
                    }
                    if(refreshCount != 3){ //refreshCount 3 means 1 min, so no need to check for reload as it will be force refresh
                        getLatestAccessToken().then((token: any) => {
                            userData.access_token = token;
                            checkForEventReload(userData, fetchDateTime).then(
                                (data) => {
                                    handleData(data, isMounted);
                                },
                                (error) => {
                                    console.log("Rrefesh error on the dashboard", error);
                                }
                            ).finally(() => { //finally block to make sure the refreshcount updates after reload check
                                checkMountedExpired(isMounted);
                            });
                        });
                    }
                    else{

                        checkMountedExpired(isMounted);
                    }
                } else {
                    getOpenEventsFromSource();
                }
            }
        }, 15000);

        // Cleanup function to clear the interval when the component unmounts
        return () => {
            clearInterval(timer);
            isMounted = false;
        }
    }, [otsaircraft, refreshCount]);


    const sendOpen = (open: any) => {
        setOpen(open);
        // if (!open) { //changing edit modal open close
        //   setEditToggle(!editToggle);
        // }
    };

    const clickEdit = (click: any) => {
        // setEditToggle(!editToggle); //changing edit modal open close
        logInformation(
            `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Edit OTS event clicked. User: ${userData?.profile?.email}`,
            moduleName,
            "clickEdit"
          );
        history.push(rootPath + "/edit-ots");
    };

    const handleLoadedData = (data: boolean) => {
        setLoadedData(data);
    };

    async function sortTheDashboard() {
        const sortedAircraft = await SortOtsCards(
            eventTypeFilters,
            otsaircraft,
            selectedField,
            clickCount
        );
        dispatch(openEvents(sortedAircraft));
    };

    const getdata = (data: any) => {
        Setcreatedata(data);
    }

    const getOTSFleetEventData = (data: any) => {
        setOtsFleetTypeData(data);
    }

    useEffect(() => {
        sortTheDashboard();
    }, [selectedField, clickCount]);

    function handleOtsEventClick(otsEvent: OtsAircraft) {
        dispatch(editAircraft(otsEvent));
        history.push(rootPath + "/event-details");
        logInformation(
            `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => OTS event details clicked for aircraft: ${otsEvent.AircraftRegistration}. User: ${userData?.profile?.email}`,
            moduleName,
            "clickEdit"
          );
    }
    function handleConversationFilter(event: any) {
        setConversationFilter(event);
    }
    function handleEditOtsEventClick(otsEvent: OtsAircraft) {
        dispatch(editAircraft(otsEvent));
        clickEdit(true);
        history.push(rootPath + "/edit-ots");
    }

    function getEventTypeCount(eventName: string) {
        let count = 0;
        if (otsaircraft) {
            otsaircraft.forEach((event) => {
                if (event.EventType === eventName) {
                    count++;
                }
            });
        }
        return eventName + " (" + count + ")";
    }

    function appliedFilter(filters: any, checked: any) {
        let filteredEvents = FilterOpenEvents(filters, openEventsMasterList);
        let viewable = filteredEvents.filter((aircraft: any) => viewEventTypes.some((viewableEventType: any) => viewableEventType.Name === aircraft.EventType));
        let list = SortOtsCards(filters, viewable, defaultSort.split('-')[0], parseInt(defaultSort.split('-')[1]));
        if (dragAndDropEventList.length > 0) {
            list = setDragAndDropOrder(list, viewEventTypes, dragAndDropEventList);
        }
        setIsLoaded(true);
        dispatch(openEvents(list));
        dispatch(setFilters(filters));
    }

    function onDrag(eventType: string) {
        setDraggedEventType(eventType);
    }

    function onDragOver(event: any) {
        event.preventDefault();
    }

    function onDrop(event: any, eventTypeName: string) {
        event.preventDefault();
        // Before swap order of event types
        const eventTypes = Array.from(new Set(otsaircraft.map(ac => ac.EventType)));
        const draggedIndex = eventTypes.indexOf(draggedEventType);
        const targetIndex = eventTypes.indexOf(eventTypeName);
        if (draggedIndex !== -1 && targetIndex !== -1) {
            // Swap the dragged and target event types
            [eventTypes[draggedIndex], eventTypes[targetIndex]] = [eventTypes[targetIndex], eventTypes[draggedIndex]];
            let newOtsaircraft = eventTypes.flatMap(eventType => otsaircraft.filter(ac => ac.EventType === eventType));
            console.log(`Moved all ${draggedEventType} to the position of ${eventTypeName}`);
            dispatch(openEvents(newOtsaircraft));
            // After the swap...
            let newEventTypes = Array.from(new Set(newOtsaircraft.map(ac => ac.EventType)));
            dispatch(setDragAndDropEventList(newEventTypes));
        } else {
            console.log("Dragged or target event type not found, cannot move.");
        }
    }

    function getOpenEventsFromSource() {
        let isoDateString = new Date().toISOString();

        //if (userData && userData.access_token !== "") {
        // call the api to get the open events 
        getLatestAccessToken().then((token) => {
            userData.access_token = token;
            getOpenEvents(userData, "").then(
                (data) => {
                    if (data == null) {
                        return;
                    }
                    dispatch(addOpenEventsMasterList(data));
                    let filteredEvents = FilterOpenEvents(eventTypeFilters, data);
                    let viewable = filteredEvents.filter((aircraft: any) => viewEventTypes.some((viewableEventType: any) => viewableEventType.Name === aircraft.EventType));
                    let list = SortOtsCards(eventTypeFilters, viewable, defaultSort.split('-')[0], parseInt(defaultSort.split('-')[1]));
                    if (dragAndDropEventList.length > 0) {
                        list = setDragAndDropOrder(list, viewEventTypes, dragAndDropEventList);
                    }
                    setIsLoaded(true);
                    dispatch(setLastRefreshed(isoDateString));
                    dispatch(openEvents(list));
                    setRefreshCount(0);
                },
                (error) => {
                    setError(error);
                }
            );
        });
        //}
    }

    function getEventTypeAccessibleState(eventName: string) {
        let isLocked = false;
        if (eventTypes) {

            eventTypes.forEach((eventType: any) => {
                if (eventType.Name === eventName) {
                    isLocked = eventType.IsLocked;
                }
            });
        }
        return isLocked;
    }

    function groupAircraftByEventType(aircraftArray: any, predicate: any) {
        if (!Array.isArray(aircraftArray)) {
            return {};
        }
        // remove that are not permitted 

        return aircraftArray.reduce((acc: any, aircraft: any) => {
            const eventType = aircraft.EventType;
            if (predicate(aircraft)) {
                if (!acc[eventType]) {
                    acc[eventType] = [];
                }
                acc[eventType].push(aircraft);
            }
            return acc;
        }, {});
    }

    const isLocked = (aircraft: any) => getEventTypeAccessibleState(aircraft.EventType);
    const isUnlocked = (aircraft: any) => !getEventTypeAccessibleState(aircraft.EventType);

    const groupedLockedAircraftByEventTypeArray = Object.entries(groupAircraftByEventType(otsaircraft, isLocked));
    groupedLockedAircraftByEventTypeArray.sort((a, b) => a[0].localeCompare(b[0]));
    const groupedUnlockedAircraftByEventTypeArray = Object.entries(groupAircraftByEventType(otsaircraft, isUnlocked));

    const LockIcon = () => (
        <div className="locked">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M1 7.66663C1 6.25263 1 5.54513 1.4395 5.10613C1.8785 4.66663 2.586 4.66663 4 4.66663H8C9.414 4.66663 10.1215 4.66663 10.5605 5.10613C11 5.54513 11 6.25263 11 7.66663C11 9.08063 11 9.78813 10.5605 10.2271C10.1215 10.6666 9.414 10.6666 8 10.6666H4C2.586 10.6666 1.8785 10.6666 1.4395 10.2271C1 9.78813 1 9.08063 1 7.66663Z" stroke="#73889b" strokeWidth="1.125" />
                <path d="M3 4.66663V3.66663C3 2.87098 3.31607 2.10791 3.87868 1.54531C4.44129 0.982697 5.20435 0.666626 6 0.666626C6.79565 0.666626 7.55871 0.982697 8.12132 1.54531C8.68393 2.10791 9 2.87098 9 3.66663V4.66663" stroke="#73889b" strokeWidth="1.125" strokeLinecap="round" />
            </svg>
        </div>
    );

    const AircraftTypeSection = ({ eventType, aircrafts, isVisible, toggleVisibility }: any) => (
        <React.Fragment key={eventType}>
            <div
                className={isVisible ? "openEventTypeDivider eventTypeLabel" : "openEventTypeDivider eventTypeLabel b-line"}
                draggable={!getEventTypeAccessibleState(eventType)}
                {...(!getEventTypeAccessibleState(eventType) ? {
                    onDrag: () => onDrag(eventType),
                    onDrop: (event) => onDrop(event, eventType),
                    onDragOver: (event) => onDragOver(event),
                } : {})}
            >
                <span className="event-type-label">
                    <div className="eventTitle">
                        {getEventTypeCount(eventType)}
                        {getEventTypeAccessibleState(eventType) && <LockIcon />}
                    </div>
                </span>
                <span className="accordian chev-down" onClick={() => toggleVisibility(eventType)} role="button" tabIndex={0} onKeyDown={(e)=>{if(e.key === 'Enter'){toggleVisibility(eventType)}}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="m6 9 6 6 6-6"/>
                    </svg>
                </span>
            </div>
            {isVisible && Array.isArray(aircrafts) && (
                <div className="ots-container">
                    {aircrafts.map(ac => (
                        <div key={`${ac.AircraftRegistration}-${ac.id}`} className="ots-card-wrapper"
                            {...(!getEventTypeAccessibleState(eventType) ? {
                                onDrop: (event) => onDrop(event, eventType),
                                onDragOver: (event) => onDragOver(event),
                            } : {})}>   
                            <OtsEventCardTile
                                otsEvent={ac}
                                onCardClick={() => handleOtsEventClick(ac)}
                                onEditClick={() => handleEditOtsEventClick(ac)}
                                onButtonClick={handleConversationFilter}
                            />
                        </div>
                    ))}
                </div>
            )}
        </React.Fragment>
    );

    const DashboardTileComponent = () => {
        const renderAircraftSections = (groupedAircraftByEventType: any) => (
            (groupedAircraftByEventType).map(([eventType, aircrafts]) => (

                <AircraftTypeSection
                    key={eventType}
                    eventType={eventType}
                    aircrafts={aircrafts}
                    isVisible={visibleEventTypes[eventType] !== false}
                    toggleVisibility={toggleVisibility}
                />
            ))
        );

        return (
            <div className="data-container">
                {renderAircraftSections(groupedLockedAircraftByEventTypeArray)}
                {renderAircraftSections(groupedUnlockedAircraftByEventTypeArray)}
                <BackToTopButton />
            </div>
        );
    };

    const selectedSortType = (sortSelected: any) => {
        dispatch(setSort(sortSelected));
        let selectedField = sortSelected.split('-')[0];
        let clickCount: number = parseInt(sortSelected.split('-')[1]);
        sortOTSGridCards(selectedField, clickCount);
        setIsLoaded(true);
    };

    async function sortOTSGridCards(selectedField: string, clickCount: number) {
        let sortedAircraft = await SortOtsCards(
            eventTypeFilters,
            otsaircraft,
            selectedField,
            clickCount
        );
        if (dragAndDropEventList.length > 0) {
            sortedAircraft = setDragAndDropOrder(sortedAircraft, viewEventTypes, dragAndDropEventList);
        }
        dispatch(openEvents(sortedAircraft));
    }

    if (error) {
        return <div>Error: {error}</div>;
    } else if (!isLoaded || otsaircraft.length === undefined) {
        return <div className="loading-container">Loading...</div>;
    } else {
        return (
            <React.Fragment>
              <ToastContainer className="my-toast-container" limit={5} />
                <Switch>
                    <Route path={rootPath + "/create-ots"}>
                        {/* <DisabledOverlay open={true} /> */}
                        <OTSModal>
                            <CreateTitleBar createventdata={createdata} title="Create new event" submitButtonText="Create"></CreateTitleBar>
                            <InlineNotificationProvider>
                            <CreateOTSEvent handledata={getdata} />
                            </InlineNotificationProvider>
                        </OTSModal>
                    </Route>
                    <Route path={rootPath + "/event-details"}>
                      <ToastComponent onToastViewClick={handleEditOtsEventClick}/>
                        <TitleBar
                            title={selectedEventType}
                            otsAircraftCount={-1}
                            editClicked={clickEdit}
                            contextPath={rootPath}
                            alertNotificationCLicked={handleEditOtsEventClick}
                            eventType=""
                        ></TitleBar>
                        <EventDetails
                            open={open}
                            loadedData={handleLoadedData}
                            conversationFilter={conversationFilter}
                            resetConversationFilter={() => setConversationFilter(null)}
                        />
                        <EditModal
                            contextPath={rootPath}
                            sendOpen={sendOpen}
                            // checkOpen={open} //changing edit modal open close
                            loadedDataEventDetails={loadedData}
                            // isEditModal={editToggle} //changing edit modal open close
                            isReopenEvent={false}
                        />
                    </Route>
                    <Route path={rootPath + "/edit-ots"}>
                    <ToastComponent onToastViewClick={handleEditOtsEventClick}/>
                        <TitleBar
                            title={selectedEventType}
                            otsAircraftCount={-1}
                            editClicked={clickEdit}
                            contextPath={rootPath}
                            alertNotificationCLicked={handleEditOtsEventClick}
                            eventType=""
                        ></TitleBar>
                        <EventDetails
                            open={open}
                            loadedData={handleLoadedData}
                        />
                        <EditModal
                            contextPath={rootPath}
                            sendOpen={sendOpen}
                            // checkOpen={open} //changing edit modal open close
                            loadedDataEventDetails={loadedData}
                            // isEditModal={editToggle} //changing edit modal open close
                            isReopenEvent={false}
                        />
                    </Route>
                    <Route path={rootPath + "/create-new-fleet-type-event"}>
                        <OTSModal>
                            <CreateTitleBar createventdata={otsFleetTypeData} 
                                        title="Create Events by Fleet" 
                                        submitButtonText="Create"></CreateTitleBar>
                            <InlineNotificationProvider>
                                <CreateOTSFleetEvent handledata={getOTSFleetEventData}></CreateOTSFleetEvent>
                            </InlineNotificationProvider>
                        </OTSModal>
                    </Route>
                    <Route path={rootPath}>
                        <ToastComponent onToastViewClick={handleEditOtsEventClick}/>
                        <TitleBar
                            title="Live events"
                            otsAircraftCount={otsaircraft.length}
                            editClicked={clickEdit}
                            contextPath={rootPath}
                            onApplyFilter={appliedFilter}
                            filteredEventTypes={eventTypeFilters}
                            sortSelected={selectedSortType}
                            alertNotificationCLicked={handleEditOtsEventClick}
                            eventType=""
                            >
                        </TitleBar>
                        <div>
                        </div>
                        <AlertBannerContainer> 
                            <SyncStatus/>
                            <AlertBanner
                                alertType="warning"
                                title="Confidential"
                                description="The information contained in this record is Confidential under Alaska’s Information Classification Policy and may not be shared without authorization from the Vice President of Maintenance & Engineering. Unauthorized release may result in discipline,  up to and including termination."
                                appName={Constants.APP_NAME_LEGAL_DISCLAIMER}
                            />
                        </AlertBannerContainer>
                        <div className="spacing"></div>
                        <GlobalTimerProvider>
                        {viewMode === "grid" ? (
                            <DashboardTileComponent />
                        ) : (
                            <OtsDashboardList
                            otsaircraft={otsaircraft}   
                            visibleEventTypes={visibleEventTypes}
                            toggleVisibility={toggleVisibility}
                            getEventTypeAccessibleState={getEventTypeAccessibleState}
                            handleOtsEventClick={handleOtsEventClick}
                            handleEditOtsEventClick={handleEditOtsEventClick}
                            onDrag={onDrag}
                            onDrop={onDrop}
                            onSortChange={selectedSortType}
                            handleOtsFilterEventClick={handleConversationFilter}
                            />
                        )}
                        </GlobalTimerProvider>
                    </Route>
                    <Redirect from="/" to="/open-events" />
                </Switch>
            </React.Fragment>
        );
    }
}

